/** ຄລາສຮ່ວມໃຫ້ spacing ຂອງແຜງຄວບຄຸມສม่ມກັນ */
export const dashboardLayout = {
  /** Card จาก @devhop/ui มี py-6 gap-6 — รีเซ็ตแล้วใส่ padding เอง */
  cardChrome: "gap-0 p-0 py-0",
  pageStack: "flex flex-col gap-6",
  standardsCardGrid:
    "grid auto-rows-fr grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-[repeat(auto-fit,minmax(17rem,1fr))] lg:gap-5",
  managementCardGrid:
    "grid auto-rows-fr grid-cols-1 gap-4 sm:grid-cols-2 lg:gap-5",
  cardGrid: "grid auto-rows-fr gap-4 sm:grid-cols-2 lg:gap-5",
  innerList: "flex flex-col gap-2.5",
  /** padding ແนวตั้ง/แนวนอນມາດຕະฐานของກາດ dashboard */
  cardPad: "px-4 py-3.5",
  metricPad: "px-3 py-3",
  listItemPad: "px-3 py-3",
  barPad: "px-4 py-3.5",
  statCardBody: "px-4 pb-3.5 pt-0",
  panelCard:
    "flex h-full flex-col gap-3 border border-border px-4 py-3.5",
} as const;
